import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { isEmpty } from 'lodash';

import { CUSTOMER_DASHBOARD, QUERY_KEYS, ROUTES } from '../../../constants';
import { popup, getAllNewsFeed, handleScroll } from '../../../utils';
import { ActivityToken, CardRightArrow, CircleSpinner } from '../../../assets/svg';
import { formatDate } from '../../../utils/common/formatHelpers';
import { useNavigate } from 'react-router-dom';
import { ResponsiveButton } from '../../shared';

export const CustomerNewsFeed = () => {
    const accountId = useSelector((state) => state.accountArray.selectedAccount);
    const navigate = useNavigate();
    const scrollBar = useRef(null);
    const [isScrolling, setIsScrolling] = useState(false);
    const newsFeedBoxRef = useRef(null);

    const { data, isFetching, isError, error } = useQuery({
        queryKey: [QUERY_KEYS.NEWS_FEED, accountId],
        queryFn: async () => await getAllNewsFeed({ account_id: accountId, filter: { status: 1 } }),
        select: (res) => ({ data: res.data, count: res.count }),
        placeholderData: { data: [], count: 0 },
        enabled: !!accountId,
    });
    if (isError) popup('error', error.message);

    const handleScrolling = () => {
        handleScroll(setIsScrolling, scrollBar, 2000);
    };

    return (
        <div
            className='h-100 w-100 activity-main ssc-shadow position-relative'
            ref={newsFeedBoxRef}
        >
            <div className='content-header'>
                <span>News Feed</span>
                <ResponsiveButton
                    icon={<CardRightArrow />}
                    title={'Archived News Feed'}
                    onClick={() => navigate(ROUTES.CUSTOMER.NEWS_FEEDS)}
                    customRef={newsFeedBoxRef}
                    breakpoint={320}
                />
            </div>
            <div
                onScroll={handleScrolling}
                className={`activity-list ${isScrolling ? 'scrolling' : 'not-scrolling'}`}
            >
                <div className='d-flex flex-column align-items-start justify-content-start list-container'>
                    {!isEmpty(data?.data)
                        ? data?.data?.map(({ id, feeds, updated_at }) => (
                              <div key={id} className='d-flex align-items-start list'>
                                  <div className='icon'>
                                      <ActivityToken />
                                  </div>
                                  <div className='text'>
                                      {feeds}
                                      <br />
                                      <div className='small fst-italic'>
                                          last updated : {updated_at ? formatDate(updated_at) : ''}
                                      </div>
                                  </div>
                              </div>
                          ))
                        : CUSTOMER_DASHBOARD.NO_NEWS_FEED}
                </div>
            </div>
            {isFetching && <CircleSpinner absolute size='3rem' />}
        </div>
    );
};
